<template>
  <div class="container">
    <!-- 语言切换按钮 -->
    <div class="lang-switcher">
      <a
        href="/PrivacyPolicy.html"
        target="_blank"
        rel="noopener noreferrer"
        class="privacy-policy"
        >{{ currentText.PrivacyPolicy }}</a
      >
      <a
        href="/UserAgreement.html"
        target="_blank"
        rel="noopener noreferrer"
        class="privacy-policy"
        >{{ currentText.UserAgreement }}</a
      >

      <div class="lang-selector" @click="toggleLangDropdown">
        <span class="lang-current">{{ langLabels[currentLang] }}</span>
        <span class="lang-arrow" :class="{ active: showLangDropdown }"></span>
      </div>
      <div class="lang-dropdown" v-show="showLangDropdown">
        <div
          v-for="(label, key) in langLabels"
          :key="key"
          class="lang-option"
          :class="{ active: currentLang === key }"
          @click="selectLang(key)"
        >
          {{ label }}
        </div>
      </div>
    </div>

    <swiper :options="swiperOption" ref="mySwiper" class="swipper-content">
      <swiper-slide class="swiper-slide">
        <div class="first-page-wrapper">
          <div class="first-page">
            <div class="animation-logo-wrapper" ref="lottieContainer"></div>
            <img
              class="slogon-wrapper"
              :src="
                currentLang == 'en'
                  ? require('../assets/image/en/slogon-en.webp')
                  : require('../assets/image/slogon.webp')
              "
            />
            <div class="number-wrapper">
              <div class="bumber-text">{{ currentText.Live }}</div>
              <div class="number-point"></div>
              <div class="number-text">{{ currentText.Chat }}</div>
              <div class="number-point"></div>
              <div class="number-text">{{ currentText.Friends }}</div>
            </div>
            <p class="name-wrapper">IN FUN TECHNOLOGY PTE. LTD.</p>
            <img
              class="charge-img"
              :src="
                currentLang == 'en'
                  ? require('../assets/image/en/fast_charge-en.webp')
                  : require('../assets/image/fast_charge.webp')
              "
              @click="goCharge()"
            />
          </div>

          <swiper
            :options="swiperOption2"
            ref="mySwiper2"
            class="swipper-content2"
          >
            <swiper-slide
              v-for="(item, index) in swiperList"
              :key="index"
              class="swiper-slide2"
            >
              <img :src="item.image" class="swiper-bottom-wrapper" />
            </swiper-slide>
          </swiper>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide">
        <div class="second-page-wrapper">
          <img
            class="pic-wrapper"
            :src="
              currentLang == 'en'
                ? require('../assets/image/en/meiyan-en.webp')
                : require('../assets/image/meiyan.webp')
            "
          />
          <p class="name-wrapper">IN FUN TECHNOLOGY PTE. LTD.</p>
          <img
            class="beauty-wrapper"
            :src="
              currentLang == 'en'
                ? require('../assets/image/en/beauty_bg-en.webp')
                : require('../assets/image/beauty_bg.png')
            "
          />
        </div>
      </swiper-slide>
      <!-- <swiper-slide class="swiper-slide">
        <div class="third-page-wrapper">
          <img class="pic-wrapper" src="../assets/image/mobile_pic2.webp" />
          <p class="name-wrapper">IN FUN TECHNOLOGY PTE. LTD.</p>
          <img class="beauty-wrapper" src="../assets/image/short_play.png" />
        </div>
      </swiper-slide> -->
      <swiper-slide class="swiper-slide">
        <div class="four-page-wrapper">
          <img
            class="pic-wrapper"
            :src="
              currentLang == 'en'
                ? require('../assets/image/en/liwu-en.webp')
                : require('../assets/image/liwu.webp')
            "
          />
          <p class="name-wrapper" style="margin-bottom: 0.5rem">
            IN FUN TECHNOLOGY PTE. LTD.
          </p>
          <img
            class="beauty-wrapper"
            :src="
              currentLang == 'en'
                ? require('../assets/image/en/send_gift-en.webp')
                : require('../assets/image/send_gift.png')
            "
          />
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide">
        <div class="five-page-wrapper">
          <img
            class="five-wrapper"
            :src="
              currentLang == 'en'
                ? require('../assets/image/en/baiwan-1-en.webp')
                : require('../assets/image/baiwan-1.webp')
            "
          />
          <div class="join-wrapper" @click="showJoin()"></div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide">
        <div class="six-page-wrapper">
          <img
            class="pic-wrapper"
            :src="
              currentLang == 'en'
                ? require('../assets/image/en/zuihou-en.webp')
                : require('../assets/image/zuihou.webp')
            "
          />
          <img
            class="slogon2-wrapper"
            :src="
              currentLang == 'en'
                ? require('../assets/image/en/title-en.webp')
                : require('../assets/image/title.webp')
            "
          />
          <div class="down-wrapper">
            <div class="button-wrapper">
              <img
                class="button-top"
                :src="
                  currentLang == 'en'
                    ? require('../assets/image/en/appstore-en.webp')
                    : require('../assets/image/appstore.png')
                "
                @click="redirectToAppStore()"
              />
              <img
                class="button-bottom"
                src="../assets/image/googleplay.png"
                @click="redirectToGooglePlay()"
              />
            </div>
          </div>
          <p class="name-wrapper2">IN FUN TECHNOLOGY PTE. LTD.</p>
        </div>
      </swiper-slide>
      <!-- 聯絡我們 -->
      <swiper-slide class="swiper-slide">
        <div class="lianxi-wrapper">
          <div class="form">
            <el-form
              label-position="top"
              :model="formLabelAlign"
              label-width="100px"
              :rules="currentRules"
              ref="formLabelAlign"
              :key="currentLang"
            >
              <el-form-item :label="currentText.formName" prop="name">
                <el-input
                  v-model="formLabelAlign.name"
                  :placeholder="currentText.placeholderName"
                ></el-input>
              </el-form-item>
              <el-form-item :label="currentText.formEmail" prop="email">
                <el-input
                  v-model="formLabelAlign.email"
                  :placeholder="currentText.placeholderEmail"
                ></el-input>
              </el-form-item>
              <el-form-item :label="currentText.formContactType" prop="type">
                <div class="custom-select" @click.stop="toggleDropdown('type')">
                  <div
                    class="custom-select__trigger"
                    :class="{ 'is-placeholder': !formLabelAlign.type }"
                  >
                    {{
                      formLabelAlign.type || currentText.placeholderContactType
                    }}
                  </div>
                  <span class="custom-select__arrow"></span>
                  <div
                    class="custom-select__dropdown"
                    v-show="showDropdowns.type"
                    @click.stop
                  >
                    <div
                      v-for="opt in typeOptions"
                      :key="opt"
                      class="custom-select__option"
                      :class="{ 'is-selected': formLabelAlign.type === opt }"
                      @click.stop="selectOption('type', opt)"
                    >
                      {{ opt }}
                    </div>
                  </div>
                </div>
              </el-form-item>
              <el-form-item prop="number">
                <el-input
                  v-model="formLabelAlign.number"
                  :placeholder="currentText.placeholderContactAccount"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="currentText.formContactReason"
                prop="region"
              >
                <div
                  class="custom-select"
                  @click.stop="toggleDropdown('region')"
                >
                  <div
                    class="custom-select__trigger"
                    :class="{ 'is-placeholder': !formLabelAlign.region }"
                  >
                    {{ regionLabel || currentText.placeholderContactReason }}
                  </div>
                  <span class="custom-select__arrow"></span>
                  <div
                    class="custom-select__dropdown"
                    v-show="showDropdowns.region"
                    @click.stop
                  >
                    <div
                      v-for="item in reasonOptions"
                      :key="item.value"
                      class="custom-select__option"
                      :class="{
                        'is-selected': formLabelAlign.region === item.value,
                      }"
                      @click.stop="selectOption('region', item.value)"
                    >
                      {{ item.label }}
                    </div>
                  </div>
                </div>
              </el-form-item>
              <el-form-item
                :label="currentText.formMessage"
                prop="textarea"
                :class="{ 'is-max': isTextareaMax }"
              >
                <el-input
                  type="textarea"
                  :rows="5"
                  maxlength="200"
                  show-word-limit
                  v-model="formLabelAlign.textarea"
                  :placeholder="currentText.placeholderMessage"
                  @mousewheel.native.stop
                  @touchmove.native.stop
                ></el-input>
              </el-form-item>
              <div
                class="re-btn"
                @click="submitForm('formLabelAlign')"
                :style="{ backgroundColor: buttonColor }"
              >
                {{ currentText.submitBtn }}
              </div>
            </el-form>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="tabs" ref="tabs">
      <div
        class="tab-item"
        v-for="(tab, index) in tabsText"
        :key="index"
        :class="{ active: index === activeIndex }"
        @click="changeSlide(index)"
      >
        {{ tab }}
        <div class="tab-indicator" v-if="index === activeIndex"></div>
      </div>
    </div>
    <div v-if="isShowJoin" class="join-pop" @click="showJoin()">
      <div class="pop"></div>
    </div>
  </div>
</template>

<script>
import lottie from "lottie-web";
import QRCode from "qrcode";
import animationData from "../assets/meoo_animation.json"; // 导入JSON动画文件
import logoUrl from "../assets/meoo.png";
import { sendMessage } from "../api/app";
import { commonMakeSign, getSignKey } from "../utils/sign";

export default {
  data() {
    return {
      currentLang: localStorage.getItem("lang") || "zh-TW", // 默认繁体
      showLangDropdown: false,
      langLabels: {
        "zh-TW": "繁體中文",
        en: "English",
      },
      i18n: {
        "zh-CN": {
          tabs: [
            "首页",
            "智能美颜",
            "趣味礼物",
            "合作主播",
            "下载APP",
            "联系我们",
          ],
          formName: "您的姓名",
          formEmail: "您的邮箱",
          formContactType: "常用联络方式",
          formContactReason: "联络类型",
          formMessage: "留言",
          placeholderName: "请输入您的姓名",
          placeholderEmail: "请输入您的邮箱",
          placeholderContactType: "请选择联络方式",
          placeholderContactAccount: "请输入所选联络方式账号",
          placeholderContactReason: "请选择联络类型",
          placeholderMessage: "请输入留言",
          submitBtn: "提交",
          reasonOptions: [
            { label: "公会入驻", value: "region1" },
            { label: "币商咨询", value: "region2" },
            { label: "主播开播", value: "region3" },
            { label: "意见反馈", value: "region4" },
            { label: "其他", value: "region5" },
          ],
          validationMessages: {
            nameRequired: "请输入您的姓名",
            nameNoSpaces: "姓名不能全是空格",
            emailRequired: "请输入您的邮箱",
            emailFormat: "请输入正确的邮箱格式",
            typeRequired: "请选择联络方式",
            numberRequired: "请输入所选联络方式账号",
            regionRequired: "请选择联络类型",
          },
          Live: "直播",
          Chat: "聊天",
          Friends: "交友",
          PrivacyPolicy: "隐私政策",
          UserAgreement: "用户协议",
        },
        "zh-TW": {
          tabs: [
            "首頁",
            "智能美顏",
            "趣味禮物",
            "合作主播",
            "下載APP",
            "聯絡我們",
          ],
          formName: "您的姓名",
          formEmail: "您的郵箱",
          formContactType: "常用聯絡方式",
          formContactReason: "聯絡型別",
          formMessage: "留言",
          placeholderName: "請輸入您的姓名",
          placeholderEmail: "請輸入您的郵箱",
          placeholderContactType: "請選擇聯絡方式",
          placeholderContactAccount: "請輸入所選聯絡方式賬號",
          placeholderContactReason: "請選擇聯絡型別",
          placeholderMessage: "請輸入留言",
          submitBtn: "提交",
          reasonOptions: [
            { label: "公會入駐", value: "region1" },
            { label: "幣商咨詢", value: "region2" },
            { label: "主播開播", value: "region3" },
            { label: "意見反饋", value: "region4" },
            { label: "其他", value: "region5" },
          ],
          validationMessages: {
            nameRequired: "請輸入您的姓名",
            nameNoSpaces: "姓名不能全是空格",
            emailRequired: "請輸入您的郵箱",
            emailFormat: "請輸入正確的郵箱格式",
            typeRequired: "請選擇聯絡方式",
            numberRequired: "請輸入所選聯絡方式賬號",
            regionRequired: "請選擇聯絡型別",
          },
          Live: "直播",
          Chat: "聊天",
          Friends: "交友",
          PrivacyPolicy: "隱私政策",
          UserAgreement: "用戶協議",
        },
        en: {
          tabs: [
            "Home",
            "Smart Beauty",
            "Fun Gifts",
            "Collaborative Hosts",
            "Download",
            "Contact Us",
          ],
          formName: "Your Name",
          formEmail: "Your Email",
          formContactType: "Contact Method",
          formContactReason: "Contact Reason",
          formMessage: "Message",
          placeholderName: "Please enter your name",
          placeholderEmail: "Please enter your email",
          placeholderContactType: "Select contact method",
          placeholderContactAccount: "Please enter your account",
          placeholderContactReason: "Select contact reason",
          placeholderMessage: "Please enter your message",
          submitBtn: "Submit",
          reasonOptions: [
            { label: "Guild Cooperation", value: "region1" },
            { label: "Coin Business Inquiry", value: "region2" },
            { label: "Streamer Broadcasting", value: "region3" },
            { label: "Feedback", value: "region4" },
            { label: "Other", value: "region5" },
          ],
          validationMessages: {
            nameRequired: "Please enter your name",
            nameNoSpaces: "Name cannot be all spaces",
            emailRequired: "Please enter your email",
            emailFormat: "Please enter a valid email format",
            typeRequired: "Please select a contact method",
            numberRequired: "Please enter your account",
            regionRequired: "Please select a contact reason",
          },
          Live: "Live",
          Chat: "Chat",
          Friends: "Friends",
          PrivacyPolicy: "Privacy Policy",
          UserAgreement: "User Agreement",
        },
      },
      swiperList: [
        {
          image: require("@/assets/image/carousel01.webp"),
        },
        {
          image: require("@/assets/image/carousel02.webp"),
        },
        {
          image: require("@/assets/image/carousel03.webp"),
        },
        {
          image: require("@/assets/image/carousel04.webp"),
        },
        {
          image: require("@/assets/image/carousel05.webp"),
        },
        {
          image: require("@/assets/image/carousel06.webp"),
        },
      ],
      activeIndex: 0,
      qrCodeImage: "",
      isShowJoin: false,
      showDropdowns: { type: false, region: false },
      typeOptions: ["Whatsapp", "WeChat", "Line", "Telegram"],
      formLabelAlign: {
        name: "",
        email: "",
        number: "",
        region: "",
        type: "",
        textarea: "",
      },
      swiperOption: {
        slidesPerView: "auto",
        normalizeSlideIndex: false,
        on: {
          slideChange: () => {
            this.activeIndex = this.$refs.mySwiper.swiper.activeIndex;
            this.$nextTick(() => {
              const tabElements =
                this.$refs.tabs.getElementsByClassName("tab-item");
              const tabElement = tabElements[this.activeIndex];
              if (tabElement) {
                const scrollLeft =
                  tabElement.offsetLeft -
                  (this.$refs.tabs.offsetWidth - tabElement.offsetWidth) / 2;
                this.$refs.tabs.scrollLeft = scrollLeft;
              }
            });
          },
        },
      },
      swiperOption2: {
        slidesPerView: "auto",
        spaceBetween: 10,
        normalizeSlideIndex: false,
        autoplay: true,
        loop: true,
      },
    };
  },
  computed: {
    currentText() {
      return this.i18n[this.currentLang];
    },
    tabsText() {
      return this.currentText.tabs;
    },
    reasonOptions() {
      return this.currentText.reasonOptions;
    },
    regionLabel() {
      const found = this.reasonOptions.find(
        (opt) => opt.value === this.formLabelAlign.region,
      );
      return found ? found.label : "";
    },
    currentRules() {
      const messages = this.currentText.validationMessages;
      return {
        name: [
          { required: true, message: messages.nameRequired, trigger: "blur" },
          {
            validator: (_rule, value, callback) => {
              if (value && value.trim() === "") {
                callback(new Error(messages.nameNoSpaces));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: messages.emailRequired, trigger: "blur" },
          { type: "email", message: messages.emailFormat, trigger: "blur" },
        ],
        type: [
          { required: true, message: messages.typeRequired, trigger: "change" },
        ],
        number: [
          { required: true, message: messages.numberRequired, trigger: "blur" },
        ],
        region: [
          {
            required: true,
            message: messages.regionRequired,
            trigger: "change",
          },
        ],
      };
    },
    isTextareaMax() {
      return this.formLabelAlign.textarea.length >= 200;
    },
    buttonColor() {
      const { name, email, number, region, type, textarea } =
        this.formLabelAlign;
      const allFilled = [name, email, number, region, type, textarea].every(
        (field) => field && field.trim() !== "",
      );
      return allFilled ? "#984afe" : "#c489fe";
    },
  },
  created() {},
  mounted() {
    this.loadAnimation();
    this.generateQRCodeWithLogo();
    document.addEventListener("click", this.closeDropdowns);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeDropdowns);
  },
  methods: {
    toggleLangDropdown() {
      this.showLangDropdown = !this.showLangDropdown;
    },
    /** 自定义下拉：切换显示 */
    toggleDropdown(key) {
      // 先关闭另一个
      Object.keys(this.showDropdowns).forEach((k) => {
        if (k !== key) this.showDropdowns[k] = false;
      });
      this.showDropdowns[key] = !this.showDropdowns[key];
    },
    /** 自定义下拉：选中项 */
    selectOption(key, value) {
      this.formLabelAlign[key] = value;
      this.showDropdowns[key] = false;
      // 触发表单校验
      this.$nextTick(() => {
        if (this.$refs.formLabelAlign) {
          this.$refs.formLabelAlign.validateField(key);
        }
      });
    },
    /** 点击外部关闭下拉 */
    closeDropdowns(e) {
      if (!e.target.closest(".custom-select")) {
        Object.keys(this.showDropdowns).forEach((k) => {
          this.showDropdowns[k] = false;
        });
      }
    },
    selectLang(lang) {
      // 关闭所有下拉
      this.showLangDropdown = false;
      Object.keys(this.showDropdowns).forEach((k) => {
        this.showDropdowns[k] = false;
      });
      this.currentLang = lang;
      localStorage.setItem("lang", lang);
      // 语言切完后异步清除校验，避免 rules 变化触发的自动校验残留
      this.$nextTick(() => {
        if (this.$refs.formLabelAlign) {
          this.$refs.formLabelAlign.clearValidate();
        }
      });
    },
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate().catch(() => false);
      if (!valid) {
        return false;
      }
      try {
        const contactTypeMap = { Whatsapp: 1, WeChat: 2, Line: 3, Telegram: 4 };
        const businessTypeMap = {
          region1: 1,
          region2: 2,
          region3: 3,
          region4: 4,
          region5: 5,
        };

        const timestamp = Math.floor(Date.now() / 1000);
        const requestData = {
          name: this.formLabelAlign.name,
          email: this.formLabelAlign.email,
          contact_type: contactTypeMap[this.formLabelAlign.type] || 0,
          contact_value: this.formLabelAlign.number,
          business_type: businessTypeMap[this.formLabelAlign.region] || 0,
          message: this.formLabelAlign.textarea,
          _ts: timestamp,
        };

        const sign = await commonMakeSign(requestData, getSignKey());
        requestData.sign = sign;

        const res = await sendMessage(requestData);
        if (res && res.data && res.data.code == 200) {
          this.$message.success(
            this.currentLang === "en"
              ? "Submitted successfully!"
              : "提交成功！",
          );
          this.$refs[formName].resetFields();
        } else {
          this.$message.error(res.data.message);
        }
      } catch (error) {
        console.error("submitForm error:", error);
        this.$message.error(
          this.currentLang === "en"
            ? "Submission failed, please try again later"
            : "提交失败，请稍后再试",
        );
      }
    },
    changeSlide(index) {
      this.activeIndex = index;
      this.$refs.mySwiper.swiper.slideTo(index);
      this.$nextTick(() => {
        const tabElement =
          this.$refs.tabs.getElementsByClassName("tab-item")[index];
        tabElement.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "start",
        });
      });
    },
    showJoin() {
      this.isShowJoin = !this.isShowJoin;
    },
    goCharge() {
      window.location.href = "https://webpay.meoo.live/";
    },
    loadAnimation() {
      const animation = lottie.loadAnimation({
        container: this.$refs.lottieContainer,
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: animationData, // JSON动画数据
      });
      animation.setSpeed(0.7);
    },
    redirectToAppStore() {
      window.location.href = "https://apps.apple.com/app/meoo/id6471481453";
    },
    redirectToGooglePlay() {
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.ufun.livestreaming";
    },
    async generateQRCodeWithLogo() {
      const qrCodeData = "https://www.meoo.live/download/index.html"; // 二维码内容

      const canvas = document.createElement("canvas");
      await QRCode.toCanvas(canvas, qrCodeData, {
        errorCorrectionLevel: "H",
        margin: 1,
        borderRadius: 10,
      });

      const ctx = canvas.getContext("2d");
      const logo = new Image();
      logo.src = logoUrl;
      logo.onload = () => {
        const logoSize = canvas.width * 0.2; // 设置logo大小
        const x = (canvas.width - logoSize) / 2;
        const y = (canvas.height - logoSize) / 2;
        ctx.drawImage(logo, x, y, logoSize, logoSize);

        this.qrCodeImage = canvas.toDataURL();
      };
    },
  },
};
</script>
<style lang="less">
html,
body,
#app,
#app > div {
  width: 100%;
  height: 100% !important;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.container {
  width: 100%;
  height: 100%;
}

/* 语言切换样式 */
.lang-switcher {
  position: fixed;
  top: 60px;
  right: 15px;
  z-index: 100;
  display: flex;
  align-items: center;
  .privacy-policy {
    color: #fff;
    // font-size: 0.085rem;
    font-size: 0.35rem;
    text-decoration: underline;
    margin-right: 15px;
  }
  .lang-selector {
    display: flex;
    align-items: center;
    gap: 6px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 16px;
    padding: 6px 12px;
    backdrop-filter: blur(5px);
    cursor: pointer;
    transition: background 0.3s;
    &:hover {
      background: rgba(0, 0, 0, 0.8);
    }
    .lang-current {
      color: #fff;
      font-size: 12px;
    }
    .lang-arrow {
      width: 0;
      height: 0;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 5px solid #fff;
      transition: transform 0.3s;
      &.active {
        transform: rotate(180deg);
      }
    }
  }
  .lang-dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 6px;
    background: rgba(0, 0, 0, 0.9);
    border-radius: 10px;
    overflow: hidden;
    backdrop-filter: blur(10px);
    min-width: 100px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
    .lang-option {
      padding: 8px 12px;
      color: rgba(255, 255, 255, 0.8);
      font-size: 12px;
      cursor: pointer;
      transition: all 0.2s;
      &:hover {
        background: rgba(152, 74, 254, 0.5);
        color: #fff;
      }
      &.active {
        background: rgba(152, 74, 254, 0.7);
        color: #fff;
      }
    }
  }
}

.charge-img {
  width: 130px;
  height: 35px;
  margin: 40px 7px 12px 15px;
  animation: zoomInOut 1s infinite;
}
@keyframes zoomInOut {
  0%,
  100% {
    transform: scale(1); /* 原始大小 */
  }
  50% {
    transform: scale(1.1); /* 放大到1.5倍 */
  }
}
.tabs {
  position: relative;
  display: flex;
  padding-top: 20px;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  z-index: 10;
}

.tabs ::-webkit-scrollbar {
  display: none;
}

.tabs .tab-item {
  position: relative;
  white-space: nowrap;
  text-align: center;
  padding: 10px;
  margin: 0 5px;
  font-weight: 400;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.4);
}

.tab-indicator {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 16px;
  height: 4px;
  background: #ffffff;
  border-radius: 15px;
  transform: translateX(-50%);
}

.tabs .active {
  font-size: 16px;
  color: #ffffff;
  bottom: 6px;
}
.swipper-content {
  position: absolute;
  top: -5px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  z-index: 1;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #000;
  width: 100% !important;
  overflow-y: scroll;
}

.first-page-wrapper {
  width: 100%;
  height: 100%;
  background-image: url("../assets/image/mobile_bg.webp");
  background-size: cover;
  overflow: auto;

  .first-page {
    width: 100%;
    height: 500px;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .animation-logo-wrapper {
    width: 142px;
    height: 101px;
    margin-top: 40%;
  }
  .slogon-wrapper {
    // width: 127px;
    height: 25px;
    margin-top: -10px;
  }
  .number-wrapper {
    font-size: 0.8rem;
    margin-top: 0.5rem;
    color: #fff;
    font-weight: 600;
    display: flex;
    .number-point {
      width: 0.15rem;
      height: 0.15rem;
      background: #fff;
      flex-shrink: 0;
      border-radius: 50%;
      margin: auto 0.5rem;
    }
  }
  .name-wrapper {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 10px;
    color: #ffffff;
    line-height: 12px;
    margin-top: 12px;
  }

  .more-wrapper {
    width: 108px;
    height: 45px;
    margin-top: 97px;
  }

  .swipper-content2 {
    // position: absolute;
    // bottom: 10px;
    height: 200px;
    width: 100%;
    margin-bottom: 20px;
    // margin-top: 150px;

    .swiper-slide2 {
      width: 90% !important;
      height: 100%;
      background: none;
    }

    .swiper-bottom-wrapper {
      width: 95%;
      background-size: cover;
      background-repeat: no-repeat;
    }
  }
}

.second-page-wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-image: url("../assets/image/mobile-bg.webp");
  background-size: cover;
}

.third-page-wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-image: url("../assets/image/mobile-bg.webp");
  background-size: cover;
}

.four-page-wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-image: url("../assets/image/mobile-bg.webp");
  background-size: cover;
}

.six-page-wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-image: url("../assets/image/mobile-bg.webp");
  background-size: cover;

  .slogon2-wrapper {
    width: 134px;
    // height: 49px;
    margin-top: 20px;
  }

  .down-wrapper {
    box-sizing: border-box;
    display: flex;
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 30px;

    .qr-wrapper {
      flex: 2;
      width: 139px;
      height: 139px;
    }
    .button-wrapper {
      flex: 3;
      display: flex;
      flex-direction: column;
      margin-left: 12px;

      .button-top {
        width: 70%; /* 设置图片宽度 */
        height: auto; /* 自适应高度 */
        margin: 0 auto;
        margin-top: 6px;
      }

      .button-bottom {
        width: 70%; /* 设置图片宽度 */
        height: auto; /* 自适应高度 */
        margin: 0 auto;
        margin-top: 15px;
      }
    }
  }

  .name-wrapper2 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 10px;
    color: rgba(255, 255, 255, 0.6);
    line-height: 12px;
    margin-top: 14px;
    padding-left: 15px;
    margin-bottom: 50px;
  }
}

.five-page-wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  position: relative;
  .five-wrapper {
    width: 100%;
    // height: 110%;
    position: absolute;
    top: 0px;
    left: 0;
  }

  .join-wrapper {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 82px;
    height: 27px;
    top: 413px;
  }
}

.pic-wrapper {
  width: calc(100% - 30px);
  height: auto;
  margin-top: 126px;
}

.name-wrapper {
  text-align: left;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 10px;
  color: #ffffff;
  line-height: 12px;
  margin-top: 42px;
  padding-left: 15px;
}

.beauty-wrapper {
  width: calc(100% - 30px);
  height: auto;
  margin-top: 12px;
}

.join-pop {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: flex-end; /* 弹窗底部对齐 */
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
}

.pop {
  width: 100%;
  height: 305px;
  background-image: url("../assets/image/mobile_join.png");
  background-size: cover;
}

// 聯絡我們
.lianxi-wrapper {
  width: 100%;
  height: 100%;
  // overflow: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  background-image: url("../assets/image/mobile-bg.webp");
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  ::-webkit-scrollbar {
    display: none !important;
    width: 0 !important ;
    -webkit-overflow-scrolling: touch;
    overflow: hidden !important;
  }
  .form {
    width: 85%;
    height: 100%;
    overflow-y: scroll;
    margin-top: 120px;
    padding: 0 0 30px 0;

    .el-form-item__label {
      color: #fff;
      line-height: 1;
      width: 100%;
      text-align: left;
      font-size: 14px;
      padding-bottom: 6px;
    }
    .el-form-item {
      margin-bottom: 22px;
    }
    .el-form-item__content {
      width: 100% !important;
    }
    .el-select {
      text-align: left !important;
      width: 100%;
    }
    .custom-select {
      position: relative;
      width: 100%;
      text-align: left;
      // 外观仿 el-input
      .custom-select__trigger {
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding: 0 30px 0 12px;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        color: #606266;
        font-size: 14px;
        cursor: pointer;
        box-sizing: border-box;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &.is-placeholder {
          color: #c0c4cc;
        }
      }
      .custom-select__arrow {
        position: absolute;
        top: 50%;
        right: 12px;
        transform: translateY(-50%);
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 6px solid #c0c4cc;
        pointer-events: none;
      }
      .custom-select__dropdown {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        z-index: 999;
        background: #fff;
        border: 1px solid #e4e7ed;
        border-radius: 4px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
        max-height: 180px;
        overflow-y: auto;
        margin-top: 4px;
      }
      .custom-select__option {
        padding: 0 12px;
        height: 36px;
        line-height: 36px;
        color: #606266;
        font-size: 14px;
        cursor: pointer;
        &:hover {
          background: #f5f7fa;
        }
        &.is-selected {
          color: #984afe;
          font-weight: 500;
          background: #faf5ff;
        }
      }
    }
    .el-form-item__error {
      color: #ff4d4f;
      position: relative;
      pointer-events: none;
      transition: opacity 0.15s ease;
    }
    .el-form-item {
      transition: margin-bottom 0.15s ease;
    }
    .re-btn {
      width: 60%;
      height: 40px;
      border-radius: 40px;
      text-align: center;
      line-height: 40px;
      color: #fff;
      font-size: 15px;
      background-color: #c489fe;
      margin: 0 auto;
      cursor: pointer;
      &:hover {
        background-color: #984afe;
      }
    }
    .is-max .el-input__count {
      color: #ff4d4f !important;
    }
  }
}
</style>
